export const CLIENT_CORRELATION_ID_HEADER = 'Client-Correlation-Id';

export const generateClientCorrelationId = (): string => crypto.randomUUID();
